import isFunction from 'lodash/isFunction'
import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import cn from '@/utils/tailwind/cn'

import Ui from '../../ui'
import ButtonClear from '../../ui/ButtonClear'
import { ALERT_INITIAL_STATE } from '../../utils/constants'
import { hasText, isFilledArray } from '../../utils/helpers'
import { ZentakeContext } from '../../utils/ZentakeContext'
import OpacityBg from '../OpacityBg'

function Alert() {
  const { pathname } = useLocation()

  const { alertConfig, setAlertConfig } = useContext(ZentakeContext)
  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    setVisible((p) => {
      const n = hasText(alertConfig?.title) || hasText(alertConfig?.description)
      return n !== p ? n : p
    })
  }, [alertConfig, pathname])

  function onClose() {
    setAlertConfig(ALERT_INITIAL_STATE)
  }

  const { title, description, buttons, canDismiss } = alertConfig

  const buttonsToUse = isFilledArray(buttons)
    ? buttons
    : [
        {
          title: 'Close',
          onPress: () => {},
        },
      ]

  function onPressButton(callback) {
    onClose()
    isFunction(callback) && callback()
  }

  return (
    isVisible && (
      <OpacityBg useMaxZIndex onClick={canDismiss ? onClose : () => {}}>
        <div className="mx-3 max-w-md flex-1 space-y-4 rounded bg-white px-4 py-4">
          {title && (
            <h4 className="text-lg font-bold text-txt-emphasis">{title}</h4>
          )}
          {description && <p className="text-sm text-txt">{description}</p>}
          <div
            className={cn('mt-4 flex w-full justify-between', {
              'flex-col justify-end gap-3': buttonsToUse?.length > 2,
            })}
          >
            {buttonsToUse?.map((button) => {
              if (button.style === 'primary') {
                return (
                  <Ui.PrimaryButton
                    danger={button.danger}
                    dataCy={button.dataCy}
                    key={button.title}
                    onClick={() => onPressButton(button?.onPress)}
                  >
                    {button?.title || ''}
                  </Ui.PrimaryButton>
                )
              }
              return (
                <ButtonClear
                  className={`border ${
                    button.style === 'destructive' ? 'hover:text-white' : ''
                  }`}
                  hoverColor={
                    button.style === 'destructive' ? 'red-500' : 'gray-200'
                  }
                  key={button.title}
                  onClick={() => onPressButton(button?.onPress)}
                >
                  {button?.title || ''}
                </ButtonClear>
              )
            })}
          </div>
        </div>
      </OpacityBg>
    )
  )
}

export default Alert
